import { changeAmountFormat } from "../../../utils/useTools";
import "../_style.scss";
import { Box } from "@mui/material";

function GetBodyList(list: any, handleClickLinkId: any, applyId?: boolean) {
  const bodyList: any[] = list.map((item: any) => [
    {
      children: (
        <Box
          className="LinkName"
          onClick={() => handleClickLinkId(item.invoiceId)}
        >
          {item.invoiceId}
        </Box>
      ),
      disabledCheckBox: applyId || item.billingKbn !== "1",
      align: "center",
      forSort: item.invoiceId,
    },
    {
      children:
        (item.billingContractorNo ?? "") +
        ":" +
        (item.billingContractorName ?? ""),
      forSort: item.billingContractorNo,
    },
    {
      children: item.depositKbn,
      forSort: item.depositKbn,
    },
    {
      children: changeAmountFormat(item.invoiceAmt),
      align: "right",
      forSort: item.invoiceAmt,
    },
    {
      children: changeAmountFormat(item.depositAmt),
      align: "right",
      forSort: item.depositAmt,
    },
    {
      children: changeAmountFormat(item.refundAmt),
      align: "right",
      forSort: item.refundAmt,
    },
  ]);

  return bodyList ?? [];
}

/**
 * 処理履歴を作成する
 * @param res
 * @returns statusBodyList
 */
function funStatusBodyList(res: any) {
  const statusBodyList: any[] = [];
  for (let i in res) {
    let createDate = new Date(res[i].createDate);
    const data = [
      {
        children: res[i].managerName,
      },
      {
        children: res[i].process,
      },
      {
        children:
          createDate.getFullYear() +
          "/" +
          (createDate.getMonth() + 1) +
          "/" +
          createDate.getDate(),
      },
      {
        children: res[i].processComment,
      },
    ];
    statusBodyList.push(data);
  }

  return statusBodyList;
}

export { GetBodyList, funStatusBodyList };
